import React, { useState } from 'react';
import './india.css';

const India = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseOver = () => {
    setIsVisible(true);
  };

  const handleMouseOut = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        className="india"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      ></div>
      <div className="contact-item-india">
        <div className={`content ${isVisible ? 'd-flex' : 'd-none'}`}>
          <div className="item">
            <p>India, Mumbai</p>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/images/bottom.svg`}
            alt="arrow bottom"
            className="arrow-down"
          />
        </div>
      </div>
    </>
  );
};

export default India;
